import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import PrimaryButton from 'shared/components/ui/PrimaryButton/PrimaryButton';
import { InfoModal } from 'shared/components/ui/info-modal/info-modal';
import { ROUTES } from 'shared/constants';

import roomClosed from 'assets/png/room-closed.png?format=webp;avif&as=picture';

export const ClosedRoomModal = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <InfoModal title={t('closeRoomModal.title')} image={roomClosed} className="grid-background">
      <p className="relative mb-4 self-stretch text-center text-md font-normal leading-[14px] text-light-grape md:mb-6">
        {t('closeRoomModal.description')}
      </p>
      <PrimaryButton
        className="w-full"
        text={'closeRoomModal.button'}
        onClick={() => {
          navigate(ROUTES.LOBBY);
        }}
      />
    </InfoModal>
  );
};
